import { useScrollReveal } from '../../hooks/useScrollReveal';

interface ServiceAreasProps {
  highlight?: string;
}

const cities = [
  'New York City', 'Westchester', 'White Plains', 'Scarsdale',
  'Bronxville', 'Larchmont', 'Rye', 'Greenwich',
  'Harrison', 'Mamaroneck', 'Ardsley', 'Tarrytown',
];

export default function ServiceAreas({ highlight }: ServiceAreasProps) {
  const leftRef = useScrollReveal();
  const rightRef = useScrollReveal();

  return (
    <section className="py-0 bg-parchment overflow-hidden">
      <div className="max-w-none">
        <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
          {/* Left — text */}
          <div
            ref={leftRef}
            className="reveal-left flex flex-col justify-center px-10 lg:px-20 py-20 lg:py-28"
          >
            <p className="font-sans text-[10px] tracking-[0.22em] uppercase text-bronze mb-4">Where We Work</p>
            <h2 className="font-serif text-5xl lg:text-6xl font-light text-dark-ink mb-6 leading-tight">
              Service Areas
            </h2>
            <p className="font-sans text-sm text-warm-gray leading-relaxed mb-10 max-w-md">
              {highlight ||
                'Providing residential architecture services in New York City, Westchester, White Plains, Scarsdale, and surrounding areas. Deep local expertise — site-specific design that responds to the character of each community.'}
            </p>

            {/* City chips */}
            <div className="flex flex-wrap gap-2">
              {cities.map((city, i) => (
                <span
                  key={i}
                  className="font-sans text-[11px] tracking-wide text-warm-gray border border-stone px-4 py-2 hover:border-wood hover:text-dark-ink transition-colors duration-300 cursor-default whitespace-nowrap"
                >
                  {city}
                </span>
              ))}
            </div>
          </div>

          {/* Right — map */}
          <div ref={rightRef} className="reveal-right relative min-h-[400px] lg:min-h-0">
            <iframe
              title="Talo Architect Service Area Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96718.23!2d-73.9200!3d40.9200!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c293a75e2a43d5%3A0xe4ee2f87ba9b5aed!2sScarsdale%2C%20NY%2010583!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus"
              className="w-full h-full absolute inset-0"
              style={{ border: 0, filter: 'grayscale(30%) contrast(1.05) sepia(10%)' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            {/* Pin overlay */}
            <div className="absolute bottom-6 left-6 bg-soft-white/95 backdrop-blur-sm px-5 py-4 border border-stone">
              <p className="font-sans text-xs font-medium text-dark-ink">Talo Architect, P.C.</p>
              <p className="font-sans text-[11px] text-warm-gray">Scarsdale, NY 10583</p>
              <a
                href="tel:+19146452940"
                className="font-sans text-[11px] text-wood hover:text-bronze transition-colors cursor-pointer mt-1 block"
              >
                (914) 645-2940
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
